export interface ExpensePermissionsConstructor {
  canEdit: boolean
  canDelete: boolean
  canApprove: boolean
  canRevise: boolean
}

export class ExpensePermissions {
  readonly canEdit: boolean
  readonly canDelete: boolean
  readonly canApprove: boolean
  readonly canRevise: boolean

  constructor(data: ExpensePermissionsConstructor) {
    this.canEdit = data.canEdit
    this.canDelete = data.canDelete
    this.canApprove = data.canApprove
    this.canRevise = data.canRevise
  }
}
